









import { defineComponent, PropType, ref } from "@vue/composition-api";
import { InputPayeeInformation, PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { systemName, formFields } from "./config";
export default defineComponent({
  name: "GustoPayout",
  components: { BaseForm },
  props: {
    savedValues: { type: Object as PropType<Partial<InputPayeeInformation>>, required: true },
    payeeInformation: { type: Object as PropType<PayeeInformation | null> },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      account: props.savedValues.gusto?.email || props.payeeInformation?.gusto?.email || undefined,
    });
    const sendInput = () => {
      const data: Partial<InputPayeeInformation> = {
        [systemName]: {
          email: values.value.email || "",
        },
      };
      emit("input", data);
    };

    const input = (newValues: FormValues) => {
      values.value = newValues;
      sendInput();
    };

    sendInput();

    return { values, formFields, input };
  },
});
